import React from 'react';
import { TagWrapper } from './styled';

export const Tag = ({ children }) => {
  return <TagWrapper>{children}</TagWrapper>;
};
